import React, { useEffect, useState } from 'react'
import "react-datepicker/dist/react-datepicker.css";
import TitleDropdown from '../../shared/common-dropdown/TitleDropdown.jsx';
import ClientDropdown from '../../shared/common-dropdown/ClientDropdown.jsx';
import UsersDropdown from '../../shared/common-dropdown/UserDropdown.jsx';
import PriorityDropdown from '../../shared/common-dropdown/PriorityDropdown.jsx';
import StatusDropdown from '../../shared/common-dropdown/StatusDropdown.jsx';

function EditTask({ TaskData, sendDataToParent }) {

  const companyDetails = <div className="col-lg-12 col-sm-6 col-12">
    <div className="card">
      <div className="card-header justify-content-between">
        <div className="card-title">Company Details</div>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table text-nowrap table-sm">
            <thead>
              <tr>
                <th scope="col">Company Type</th>
                <th scope="col">Company</th>
                <th scope="col">Ref. No</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{TaskData.ClientCompanyTypeName}</td>
                <td>{TaskData.ClientCompanyName}</td>
                <td>{TaskData.ReferenceNumber}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>;

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    sendDataToParent((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  function handleDropdownChange(selectedOption, e) {
    if (e.name === "AssignedToUserId") {
      if (selectedOption !== null) {
        sendDataToParent((prevState) => ({
          ...prevState,
          AssignedToUserId: selectedOption.value
        }));
      } else {
        sendDataToParent((prevState) => ({
          ...prevState,
          AssignedToUserId: null
        }));
      }
    } else if (e.name === "PriorityId") {
      if (selectedOption !== null) {
        sendDataToParent((prevState) => ({
          ...prevState,
          PriorityId: selectedOption.value
        }));
      } else {
        sendDataToParent((prevState) => ({
          ...prevState,
          PriorityId: null
        }));
      }
    } else if (e.name === "StatusId") {
      if (selectedOption !== null) {
        sendDataToParent((prevState) => ({
          ...prevState,
          StatusId: selectedOption ? selectedOption.value : null
        }));
      } else {
        sendDataToParent((prevState) => ({
          ...prevState,
          StatusId: null
        }));
      }
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-12 col-sm-6 col-12">
          <div className="input-blocks1 mb-3">
            <TitleDropdown
              modelName="TitleId"
              required={true}
              placeholder={"Type to create new title or search existing"}
              selectedValue={TaskData.TitleId}
              isDisable={true}
            />
          </div>
        </div>
        <div className="col-lg-12 col-sm-6 col-12">
          <div className="input-blocks1 mb-3">
            <ClientDropdown
              modelName="ClientId"
              selectedValue={TaskData.ClientId}
              isDisable={true}
            />
          </div>
        </div>
        {TaskData.ClientCompanyName !== null ? companyDetails : ""}


        <div className="col-lg-4 col-sm-4 col-12">
          <div className="input-blocks1 mb-3">
            <UsersDropdown
              modelName="AssignedToUserId"
              required={true}
              onChangeDropdown={handleDropdownChange}
              selectedValue={TaskData.AssignedToId}
            />
          </div>
        </div>
        <div className="col-lg-4 col-sm-4 col-12">
          <div className="input-blocks1 mb-3">
            <PriorityDropdown
              modelName="PriorityId"
              required={true}
              onChangeDropdown={handleDropdownChange}
              selectedValue={TaskData.PriorityId}
            />
          </div>
        </div>
        <div className="col-lg-4 col-sm-4 col-12">
          <div className="input-blocks1 mb-3">
            <StatusDropdown
              modelName="StatusId"
              required={true}
              onChangeDropdown={handleDropdownChange}
              selectedValue={TaskData.StatusId}
            />
          </div>
        </div>
        <div className="col-lg-12 col-sm-6 col-12">
          <div className="summer-description-box transfer mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control h-100"
              rows="2"
              name="Description"
              value={TaskData.Description}
              onChange={handleChange}
            />
            <p className="mt-1">Maximum 1000 Characters</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default EditTask